import { type StateType } from '../../states';
import { type FavoritesState } from '../../states/favorites';
import { type Selector } from '../../types/selectors';

const emptyObject = {};
const emptyArr: [] = [];

export const selectFavoritesState: Selector<FavoritesState> = (state: StateType) => state.favorites ?? emptyObject;

//#region state.favorites
export const selectFavoritesOptimist: Selector<Array<number>> = (state: StateType) =>
  selectFavoritesState(state).optimist ?? emptyArr;

export const selectFavoritesIds: Selector<Array<number>> = (state: StateType) =>
  selectFavoritesState(state).ids ?? emptyArr;
//#endregion
